import React from 'react'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import { Box, Chip, Grid, Paper, Stack, Typography } from '@mui/material'
import moment from 'moment'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import { isHiddenEntryKey } from '../../ePCR/liveCapture/liveUi'

const TreatmentModule = ({ treatment }) => {
  const moduleList = [...(treatment?.modules ?? [])].sort(
    (a, b) => moment(b.dateTime) - moment(a.dateTime),
  )

  return (
    <DetailsBox
      title="Treatment"
      rows={[
        { label: 'Notes', value: treatment.treatmentText, fullWidth: true },
      ]}
    >
      {moduleList.map((module, index) => (
        <Grid
          container
          key={module.entryId ?? `${module.dateTime}-${index}`}
          rowGap={1}
        >
          <Grid item xs={12}>
            <Box display="flex" gap={2} alignItems="center">
              <Typography
                variant="title2"
                fontSize="1rem"
                sx={{ textDecoration: 'underline' }}
              >
                {module.moduleName}
              </Typography>
              <Chip
                size="small"
                sx={{ borderRadius: 1 }}
                color="info"
                label={moment(module.dateTime).format('HH:mm')}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            display="flex"
            flexWrap="wrap"
            columnGap={5}
            rowGap={1}
          >
            {Object.keys(module)
              .filter(
                (x) =>
                  !isHiddenEntryKey(x, ['dateTime', 'moduleName', 'Notes']) &&
                  module[x] !== undefined &&
                  module[x] !== null,
              )
              .map((x) => (
                <Box key={x} display="flex" gap={0.5}>
                  <Typography fontWeight="bold">{x}: </Typography>
                  <Typography variant="body1">
                    {Array.isArray(module[x])
                      ? module[x].join(', ')
                      : module[x]}
                  </Typography>
                </Box>
              ))}
          </Grid>
          {module?.['Notes'] && (
            <Grid item xs={12} lg={6}>
              <Box display="flex" gap={0.5}>
                <Typography fontWeight="bold">Notes: </Typography>
                <Typography variant="body1">{module['Notes']}</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      ))}
    </DetailsBox>
  )
}
export default TreatmentModule
